module.exports = __webpack_public_path__ + "static/media/icon_step_02.69602391.webp";